module.exports = __webpack_public_path__ + "static/media/bigthree-6.5add626d.jpg";